import { useEffect, useRef, useState } from "react";
import moment, { Moment } from "moment";

import { clearSurveysFilter } from "Redux/filtersSlice";
import {
  Button,
  Card,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  StandardTextFieldProps,
  Typography,
} from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ClockPicker } from "@mui/x-date-pickers/ClockPicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import Modal from "Components/Modal";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import _ from "lodash";

interface IProps extends StandardTextFieldProps {
  label?: string;
  data?: { [key: string]: any } | null;
  setData?: (value: any) => void;
  name: string;
}

const timeToMoment = (time: string) => {
  const hour = Number(time.split(":")[0]);
  const minute = Number(time.split(":")[1]);

  const initialTime = moment().utcOffset(0);
  initialTime.set({ hour, minute, second: 0, millisecond: 0 });
  initialTime.toISOString();
  initialTime.format();
  return initialTime;
};

export default function TimePicker2({ label, size, data, name, setData, disabled }: IProps) {
  const mounted = useRef(false);

  const [date, setDate] = useState<Moment | null>(data && data[name] ? timeToMoment(data[name]) : timeToMoment("00:00"));
  const [view, setView] = useState<"hours" | "minutes">("hours");
  const [showModal, setShowModal] = useState(false);
  const { mode } = useAppSelector((state) => state.passage);
  const dispatch = useAppDispatch();

  const toggleModal = () => setShowModal((prev) => !prev);

  useEffect(() => {
    if (mounted.current) {
      console.log(date?.format("HH:mm:ss"), "vdddvdv");
      if (setData) {
        setData(date?.format("HH:mm:ss"));
      }
    } else {
      mounted.current = true;
    }
  }, [date]);

  //   const handleDeleteTime = () => {
  //     const newSurveys = { ...surveys };
  //     delete newSurveys[name];
  //     setDate(null);
  //     dispatch(clearSurveysFilter(newSurveys));
  //   };

  return (
    <>
      <Modal open={showModal} onClose={toggleModal} size="xs">
        <Card sx={{ p: 3 }}>
          <Stack direction="row-reverse" justifyContent="center" alignItems="center" spacing={1} mb={1}>
            {date
              ?.format("HH:mm:ss")
              .split(":")
              .map((i, index) => {
                let value: any;
                if (index === 0) {
                  value = "hours";
                } else if (index === 1) {
                  value = "minutes";
                } else {
                  value = "seconds";
                }

                return (
                  <>
                    <Button
                      sx={{ fontSize: "20px", bgcolor: view === value ? "#eee" : "" }}
                      color="black"
                      className="fa-number"
                      onClick={() => setView(value)}
                    >
                      {i}
                    </Button>
                    {index === 0 && <Typography>:</Typography>}
                  </>
                );
              })}
          </Stack>

          <LocalizationProvider dateAdapter={AdapterMoment}>
            <ClockPicker date={date} onChange={(newDate) => setDate(newDate)} view={view} />
          </LocalizationProvider>
          <Stack direction="row" style={{ width: "100%", justifyContent: "space-between" }}>
            <Button variant="contained" size="large" sx={{ mt: 3, width: "45%" }} onClick={toggleModal}>
              تایید
            </Button>
            <Button variant="contained" size="large" sx={{ mt: 3, width: "45%" }}>
              بازنشانی
            </Button>
          </Stack>
        </Card>
      </Modal>
      <FormControl fullWidth variant="outlined" size={size} onClick={() => setShowModal(true)} disabled={mode === "now"}>
        <InputLabel shrink={Boolean(data && data[name])}>{label}</InputLabel>
        <OutlinedInput
          notched={Boolean(data && data[name])}
          type="text"
          label={label}
          inputProps={{ readOnly: true, className: "fa-number" }}
          disabled={disabled}
          value={!_.isEmpty(data) && data[name] ? data[name] : ""}
          required={true}
          endAdornment={
            <InputAdornment position="end">
              <IconButton edge="end" onClick={() => setShowModal(true)} disabled={disabled || mode === "now"}>
                <AccessTimeIcon fontSize={size} />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </>
  );
}
